import { cn } from 'mode-shared/utils';

export const NoData = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div className={cn('flex items-center justify-center h-full w-full', className)}>
      <p className="text-neutral-500 text-sm font-medium">{children ? children : 'No data available'}</p>
    </div>
  );
};
